import bridgemateAPI from '../../../apis/bridgemate-apigateway'
import axios from 'axios';
import { S3_ENDPOINT } from '../../../apis/endpoints'
import { uploadTypes } from '../../helpers/AppConsts'
import { indexOfMonth} from '../../helpers/DateUtils'

export const uploadArtifact = (files, event, action, uploadType) => {

    const { event_date: eventDate,
            event_club: club,
            event_year: year,
            event_month: month,
            event_day: day } = event;
    var file = files[0];
    debugger;
    var monthIndex = indexOfMonth(month)

    let fileNameModified;
    if(uploadType === uploadTypes.RESULTS_UPLOAD){
        fileNameModified = `${club}-${year}-${monthIndex}-${day}-${Date.now()}-results.html`;
    }
    if(uploadType === uploadTypes.HANDS_UPLOAD){
      fileNameModified = `${club}-${year}-${monthIndex}-${day}-${Date.now()}-hands.html`;
    }
    if (uploadType === uploadTypes.IMAGE_UPLOAD) {
      fileNameModified = `${club}-${year}-${monthIndex}-${day}-image.png`;
    }

    console.log("fileNameModified....",fileNameModified)

    bridgemateAPI.post('/event/upload', {
      filename: fileNameModified, //file.name,
      filetype: file.type
    }).then(function(url){
        var options = { headers: { 'Content-Type': file.type }};

        axios.put(url.data,file,options).then(function (response) {
            let endpoint = S3_ENDPOINT +'/'+fileNameModified;

            if (uploadType === uploadTypes.HANDS_UPLOAD){
                event.event_hands = endpoint
            }

            if(uploadType === uploadTypes.RESULTS_UPLOAD){
                event.event_results = endpoint
            }
            else if(uploadType === uploadTypes.WINNERS_UPLOAD){
                event.event_winners = endpoint
            }else {
                event.event_img = endpoint
            }

            event.registered_players = ["placeholder"];

            event.event_date = eventDate;
            action(event);
        })
        .catch(function (error) {
            console.log(error);
        });
    }
);
}
